import { Component } from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {DEFAULT_POINT_PACKS, IPointPack} from '../../../shared/constants/points.constants';

@Component({
  selector: 'app-points-shop',
  templateUrl: './points-shop.component.html',
  styleUrls: ['./points-shop.component.scss'],
  imports: [CommonModule],
})
export class PointsShopComponent {
  pointPacks: IPointPack[] = DEFAULT_POINT_PACKS;

  constructor(private router: Router) {
  }

  goToShop() {
    this.router.navigate(['/shop']);
  }
}
